// MenuItem.js
import { NavLink } from "react-router-dom"
import styles from './MenuItem.module.css'

function MenuItem({link_route, link_caption, icon}){
    return (
        <NavLink 
            title={link_caption} 
            className={styles.MenuItem} 
            to={link_route}
        >
            {icon}
            <span style={{ marginLeft: '8px' }}>{link_caption}</span>
        </NavLink>
    )
}

export default MenuItem